<template>
  <div>
    <h3 class="mb-5">Company Culture</h3>
    <div class="h4 mb-5">顯示於Carrer Page頁面</div>
    <div>
      <PageCollapse v-for="(item, i) in career.cultures" :key="item.id">
        <template v-slot:head>
          <h3>Company Culture {{ i + 1 }}</h3>
        </template>
        <template v-slot:body>
          <!-- title -->
          <div class="form-item py-5 d-flex">
            <h4 class="w-180px">Title</h4>
            <div class="flex-grow-1 flex-basis-0">{{ item.title }}</div>
          </div>
          <!-- description -->
          <div class="form-item py-5 d-flex">
            <h4 class="w-180px">Description</h4>
            <div class="flex-grow-1 flex-basis-0">{{ item.description }}</div>
          </div>
          <!-- Visual -->
          <div class="px-5 py-5 d-flex">
            <h4 class="w-180px">Visual</h4>
            <div class="flex-grow-1">
              <div
                class="bg-cover bg-center w-120px h-180px ml-auto"
                :style="{
                  'background-image': `url(${item.visual})`,
                }"
              ></div>
            </div>
          </div>
        </template>
      </PageCollapse>
    </div>
  </div>
</template>

<script>
import PageCollapse from '@/components/PageCollapse.vue';

export default {
  props: {
    career: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    PageCollapse,
  },
};
</script>

<style></style>
